// 用户自定义内容长度限制
export const UGC_MAX_LENGTH = {
    // 用户
    USER: {
        CORP_NAME: 50, // 企业名称 50
        EMAIL: 100 // 邮箱 100
    },
    // 消息
    MSG: {
        TARGET_NAME: 80, // 提醒对象姓名 80
        TARGET_EMAIL: 100 // 提醒对象邮箱号 100
    }
};
